import React from "react";
import Swal from "sweetalert2";
function ContactForm() {

  const handleSubmit = (e) => {
    e.preventDefault();

    const formURL =
      "https://docs.google.com/forms/d/e/1FAIpQLScc6yB2QbkuNOIyr_xEYyJmywFseyvW2X_Gbu7KKlLiymwtTg/formResponse";

    const formData = new FormData(e.target);

    fetch(formURL, {
      method: "POST",
      mode: "no-cors",
      body: formData,
    });

    Swal.fire({
        title: "Form Submitted!",
        text: "Thank you! Your message has been submitted successfully. We’ll get back to you shortly.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
    });
    e.target.reset();
  };

  return (
    <div className="contact-form-ui">
        <form onSubmit={handleSubmit}>

            <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="text-white">First name</label>
                    <input type="text" name="entry.1063790246" className="form-control" placeholder="Enter First Name" required
                    />
                </div>

                <div className="col-md-6 mb-3">
                    <label className="text-white">Last name</label>
                    <input type="text" name="entry.680938714" className="form-control" placeholder="Enter Last Name" required
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 mb-3">
                    <label className="text-white">Email address</label>
                    <input type="email" name="entry.894047119" className="form-control" placeholder="Enter Email Address" required />
                </div>

                <div className="col-md-12 mb-3">
                    <label className="text-white">What do you want to know?</label>
                    <textarea name="entry.1366511568" className="form-control" placeholder="Write Questions Here" />
                </div>
            </div>

            <div className="text-center mb-3">
                <button type="submit" className="btn btn-primary mb-2">
                    Submit Details <i className="fas fa-arrow-right"></i>
                </button>
            </div>

        </form>
    </div>
  );
}

export default ContactForm;